import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { CircularProgress } from '@material-ui/core';
export function renderApIngestionDocs({ apIngestionDocuments, ignoreGroups }) {
	let lastGroupNumber = 1;
	return (
		<div>
			{apIngestionDocuments.map((apIngestionDocument, index) => {
				if (!apIngestionDocument) {
					return <div key={index}>Missing document #{index}</div>;
				}

				const {
					apIngestionDocumentId,
					pageNumber,
					ingestionStatus,
					groupNumber,
					matchedApGuideSlug,
				} = apIngestionDocument;

				let docName;
				if (matchedApGuideSlug) {
					docName = _.startCase(matchedApGuideSlug);
				}

				let style = {};
				if (lastGroupNumber !== groupNumber && !ignoreGroups) {
					lastGroupNumber = groupNumber;
					style = { marginTop: 5, paddingTop: 5, borderTop: '1px solid #a9d7fb' };
				}

				if (ingestionStatus === 'matched') {
					return (
						<div key={apIngestionDocumentId} style={style}>
							<span style={{ color: 'green', display: 'inline-block', width: '15px' }}>✓</span>
							<span>
								Page {pageNumber}: {docName}
							</span>
						</div>
					);
				} else if (ingestionStatus === 'missingData') {
					style.color = '#444';
					return (
						<div key={apIngestionDocumentId} style={style}>
							<span style={{ display: 'inline-block', color: 'red', width: '15px' }}>x</span>
							<span>
								Page {pageNumber}: {docName} : Missing Data
							</span>
						</div>
					);
				} else if (ingestionStatus === 'noMatch') {
					return (
						<div key={apIngestionDocumentId} style={{ color: '#555' }}>
							<span style={{ display: 'inline-block', width: '15px' }}>?</span>
							<span>
								Page {pageNumber}: {_.startCase(ingestionStatus)}
							</span>
						</div>
					);
				} else if (ingestionStatus === 'duplicate') {
					return (
						<div key={apIngestionDocumentId} style={{ color: '#888' }}>
							<span style={{ display: 'inline-block', width: '15px' }}>-</span>
							<span>
								Page {pageNumber}: {docName} : {_.startCase(ingestionStatus)}
							</span>
						</div>
					);
				} else if (ingestionStatus === 'possibleMissRead') {
					return (
						<div key={apIngestionDocumentId} style={{ color: '#888' }}>
							<span style={{ display: 'inline-block', width: '15px' }}>-</span>
							<span>
								Page {pageNumber}: {docName} : {_.startCase(ingestionStatus)}
							</span>
						</div>
					);
				} else if (ingestionStatus === 'warning') {
					return (
						<div key={apIngestionDocumentId} style={{ color: '#555' }}>
							<span style={{ display: 'inline-block', color: 'orange', width: '15px' }}>x</span>
							<span>
								Page {pageNumber}: {_.startCase(ingestionStatus)}
							</span>
						</div>
					);
				} else {
					style.color = '#444';
					return (
						<div key={apIngestionDocumentId} style={style}>
							<span style={{ display: 'inline-block', width: '15px' }}>
								<CircularProgress size="13px" style={{ marginRight: 4 }} />
							</span>
							<span>
								Page {pageNumber}: {_.startCase(ingestionStatus)}
							</span>
						</div>
					);
				}
			})}
		</div>
	);
}

renderApIngestionDocs.propTypes = {
	apIngestionDocuments: PropTypes.array.isRequired,
	apGuideMap: PropTypes.object.isRequired,
	ignoreGroups: PropTypes.bool,
};
